import {connect} from 'react-redux'
import CheckCashing from '../components/CheckCashingView'
import _ from 'lodash'
import {B} from '../../../../helpers'
import {changeStep} from "../../../../layouts/Content/modules/step";
import {appSetVal, appSetObj, appSetServerVal, checkFields, appCall} from '../../../../store/application'
import {updateAmounts, submitTransaction} from "../modules/checkcashing";
import {changeNumber, initCustomer, resetCustomer} from "../../../../store/customer";
import {CASH_A_CHECK_TRANSACTION_STATUSES} from "../../../../constants";

const mapDispatchToProps = {
  updateAmounts: updateAmounts,
  appSetVal: appSetVal,
  appSetObj: appSetObj,
  appSetServerVal: appSetServerVal,
  changeStep: changeStep,
  checkFields: checkFields,
  appCall: appCall,
  submitTransaction: submitTransaction,
  resetMayaCustomer: resetCustomer,
  initMayaCustomer: initCustomer,
  changeMayaNumber: changeNumber
};

const mapStateToProps = (state) => {
  const { s_customer_id, s_customer_cell_phone,
    check_id, check_maker_id, check_transaction_id, payment_guid, transaction_status} = state.app.x_data;
  const { title, icon } = state.app.product_data;
  const { customer_id } = state.customer;

  return {
    icon,
    title,
    s_customer_ready: B(s_customer_id),
    customer_ready: B(customer_id),
    s_customer_cell_phone: s_customer_cell_phone,
    ready_to_review: B((check_id && check_maker_id && check_transaction_id && payment_guid) && transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.REVIEW)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckCashing)


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/containers/CheckCashingContainer.js